module.exports = __webpack_public_path__ + "img/ic_signout.80f9df4a.svg";